// extracted by mini-css-extract-plugin
export default {"captcha":"ReCaptchaModal-module__captcha__dRJLc"};